import { FC } from 'react';
import { PanelGroup, PanelGroupProps } from 'react-resizable-panels';

export const WbDockableGroup: FC<PanelGroupProps> = props => {
  return <PanelGroup {...props}>{props.children}</PanelGroup>;
};
